import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const MAP: Record<string, { label: string; cls: string }> = {
  created: { label: "Criada", cls: "bg-muted text-muted-foreground" },
  warming_up: { label: "Aquecendo", cls: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30" },
  listening: { label: "Ouvindo", cls: "bg-primary/15 text-primary border-primary/30 animate-pulse" },
  thinking: { label: "Pensando", cls: "bg-blue-500/15 text-blue-700 dark:text-blue-400 border-blue-500/30" },
  speaking: { label: "Falando", cls: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30" },
  paused: { label: "Pausada", cls: "bg-muted text-muted-foreground" },
  interrupted: { label: "Interrompida", cls: "bg-orange-500/15 text-orange-700 dark:text-orange-400 border-orange-500/30" },
  degraded: { label: "Degradada", cls: "bg-yellow-500/15 text-yellow-700 dark:text-yellow-400 border-yellow-500/30" },
  ending: { label: "Encerrando", cls: "bg-muted text-muted-foreground" },
  completed: { label: "Concluída", cls: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30" },
  abandoned: { label: "Abandonada", cls: "bg-muted text-muted-foreground" },
  error: { label: "Erro", cls: "bg-destructive/15 text-destructive border-destructive/30" },
};

export function SessionStatusBadge({ status, className }: { status: string; className?: string }) {
  const meta = MAP[status] ?? { label: status, cls: "bg-muted" };
  return (
    <Badge variant="outline" className={cn("border", meta.cls, className)}>
      {meta.label}
    </Badge>
  );
}
